import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';


// 获取枚举列表
export const GetEnumConfigList = (params) => {
	return reqF("post", "/api/sysConfig/EnumConfig/GetEnumConfigList", params)
};

// 保存枚举配置
export const SaveEnumConfig = (params) => {
	return reqF("post", "/api/sysConfig/EnumConfig/SaveEnumConfig", params)
};

// 删除枚举配置
export const DelEnumConfig = (params) => {
	return reqF("post", "/api/sysConfig/EnumConfig/DelEnumConfig", params)
};

// 获取枚举配置详情
export const GetEnumConfigDetail = (params) => {
	return reqF("post", "/api/sysConfig/EnumConfig/GetEnumConfigDetail", params)
};

// 根据编号获取枚举配置列表
export const GetEnumConfigListByCode = (params) => {
	return reqF("post", "/api/sysConfig/EnumConfig/GetEnumConfigListByCode", params)
};

// 获取枚举配置列表填充下拉框
export const GetEnumConfigDropListByCode = (params) => {
	return reqF("post", "/api/sysConfig/EnumConfig/GetEnumConfigDropListByCode", params)
};